export default __webpack_public_path__ + "static/media/mob_cssweb.c50ee1a0.jpg";